import { all } from '@redux-saga/core/effects';
import sharedAssetSagas from '../asset/sagas';
import assetGridSagas from '../../features/AssetGrid/redux/sagas/asset';
import riskSagas from '../risk/sagas';
import inspectionSagas from '../inspections/sagas';
import facilitySagas from '../facility/sagas';
import polygonHighlightSagas from '../../features/polygonHighlight/polygonHighlight.saga';

export const sagas = function* rootSaga() {
	yield all([
		...sharedAssetSagas,
		...assetGridSagas,
		...riskSagas,
		...inspectionSagas,
		...facilitySagas,
		...polygonHighlightSagas,
	]);
};

export default sagas;
